// Define types for ProfileDetail and TransactionTable
export interface ProfileDetail {
  id: string;
  Details: string;
  response: string;
}

export interface Transaction {
  id: string;
  Title: string;
}

// Profile details array with type annotations
export const ProfileDetailList: ProfileDetail[] = [
  { id: "1", Details: "username", response: "" },
  { id: "2", Details: "email", response: "" },
  { id: "3", Details: "firstname", response: "" },
  { id: "4", Details: "lastname", response: "" },
  { id: "5", Details: "referral code", response: "" },
];

// Transaction table array with type annotations
export const TransactionTable: Transaction[] = [
  { id: "2", Title: "Round Id" },
  { id: "3", Title: "Type" },
  { id: "4", Title: "Amount" },
  { id: "5", Title: "Date" },
  { id: "6", Title: "Time" },
  { id: "7", Title: "Status" },
];
